import React from "react";

class Mantra_18_Canvas extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { message } = this.props;
    return (
      <section className="canvas_section mantra22_canvas setdiv_canvas" id={"canvas_generate_" + this.props.module_name}>
        <p>{message}</p>
      </section>
    );
  }
}

export default Mantra_18_Canvas;
